const uk_img = require("../assets/media/flags/uk.png");
const usa_img = require("../assets/media/flags/usa.png");
const australia_img = require("../assets/media/flags/australia.png");
const canada_img = require("../assets/media/flags/canada.png");
const france_img = require("../assets/media/flags/france.png");
const german_img = require("../assets/media/flags/german.png");
const india_img = require("../assets/media/flags/india.png");
const ireland_img = require("../assets/media/flags/ireland.png");
const southafrica_img = require("../assets/media/flags/south-africa.png");

const PoundCoin = require("../assets/media/coins/pound-coin.png");
const DollarCoin = require("../assets/media/coins/dollar-coin.png");
const EuroCoin = require("../assets/media/coins/euro-coin.png");

const EcosystemGoIcon = require("../assets/media/ecosystem_go.png");
const EcosystemProIcon = require("../assets/media/ecosystem_pro.png");
const EcosystemTrialIcon = require("../assets/media/ecosystem_trial.png");

const notification_img = require("../assets/media/notifications/notification.png");
const collaboration_img = require("../assets/media/notifications/collaboration.png");

export const TerritoryOptions = [
  "UK",
  "USA",
  "Ireland",
  "Canada",
  "France",
  "India",
  "German",
  "SouthAfrica",
  "Australia",
];

export const services_routing = [
  {
    tier1: { id: 13, active: true },
    tier2: [
      { id: 64, active: true },
      { id: 65, active: true },
      { id: 66, active: true },
      { id: 67, active: true },
      { id: 68, active: true },
      { id: 69, active: true },
      { id: 70, active: true },
    ],
  },
  {
    tier1: { id: 2, active: true },
    tier2: [
      { id: 21, active: true },
      { id: 40, active: true },
      { id: 44, active: true },
    ],
  },
  {
    tier1: { id: 3, active: true },
    tier2: [
      { id: 42, active: true },
      { id: 17, active: true },
      { id: 18, active: true },
      { id: 36, active: true },
      { id: 25, active: true },
    ],
  },
  {
    tier1: { id: 9, active: true },
    tier2: [],
  },
  {
    tier1: { id: 0, active: true },
    tier2: [
      { id: 0, active: true },
      { id: 1, active: true },
      { id: 19, active: true },
      { id: 39, active: true },
    ],
  },
  {
    tier1: { id: 7, active: true },
    tier2: [
      { id: 45, active: true },
      { id: 46, active: true },
      { id: 47, active: true },
    ],
  },
  {
    tier1: { id: 4, active: true },
    tier2: [
      { id: 23, active: true },
      { id: 24, active: true },
      { id: 43, active: true },
      { id: 37, active: true },
    ],
  },
  {
    tier1: { id: 1, active: true },
    tier2: [
      { id: 15, active: true },
      { id: 16, active: true },
      { id: 26, active: true },
      { id: 27, active: true },
    ],
  },
  {
    tier1: { id: 5, active: true },
    tier2: [
      { id: 35, active: true },
      { id: 20, active: true },
      { id: 38, active: true },
    ],
  },
  {
    tier1: { id: 8, active: true },
    tier2: [
      { id: 48, active: true },
      { id: 49, active: true },
      { id: 50, active: true },
      { id: 51, active: true },
    ],
  },
  {
    tier1: { id: 6, active: true },
    tier2: [
      { id: 30, active: true },
      { id: 31, active: true },
      { id: 41, active: true },
    ],
  },
];

export const noteOptions = [
  { value: "calendar", label: "Calendar" },
  { value: "financial", label: "Financial" },
  { value: "added-appointment", label: "Added appointment" },
  { value: "accepted-task", label: "Accepted task" },
  { value: "complaint", label: "Complaint" },
  { value: "admin-request", label: "Admin request" },
  { value: "completed-job", label: "Completed job" },
  { value: "signed-off", label: "Signed off *by member or admin" },
  { value: "question", label: "Asked a question" },
  { value: "request_pdf", label: "Requested a PDF" },
  { value: "request_image", label: "Requested an image" },
  { value: "request_video", label: "Requested a video" },
  { value: "Assign tokens", label: "Assigned tokens" },
  { value: "complete-concierge", label: "Completed concierge" },
  { value: "Review", label: "Review" },
];
export const user_actions = [
  { value: "started", label: "Walk through landing" },
  { value: "purchase a product", label: "Purchase a product" },
  { value: "complete review", label: "Post a review" },
  { value: "create a ticket", label: "Create a ticket" },
  { value: "check user infomation", label: "Check to upgrade full user" },
  { value: "terminate a ticket", label: "Terminate a ticket" },
  { value: "spend tokens", label: "Spend tokens" },
  { value: "Donate to a cause", label: "Donate to a cause" },
  { value: "add payment method", label: "Add a payment method" },
  { value: "recommend a product", label: "Recommend a product" },
  { value: "poll creation", label: "Take a poll" },
  { value: "attend to event", label: "Attend an event" },
  { value: "add a friend", label: "Add a friend" },
  { value: "Excercise goal", label: "Excercise goal" },
  { value: "share token", label: "Share tokens with friend" },
  { value: "volunteer to help", label: "Volunteer to help" },
  { value: "add a day goal", label: "Add a day goal" },
  { value: "complete a goal", label: "Complete a goal" },
  { value: "add superskill", label: "Add a superskill" },
  { value: "build a future", label: "Build a future" },
  { value: "comment on feeds", label: "Comment on feeds" },
  { value: "post a question", label: "Post a question" },
  { value: "post a milestone", label: "Post a milestone" },
  { value: "post an experience", label: "Post an experience" },
  { value: "post an idea", label: "Post an idea" },
  { value: "post help needed", label: "Ask for help" },
  { value: "request concierge", label: "Concierge request" },
  { value: "help a member", label: "Help a member" },
  { value: "add your first name", label: "Add your first name" },
  { value: "add a profile pic", label: "Add a profile pic" },
  { value: "Setup TokenPay Card", label: "Setup TokenPay Card" },
  { value: "Share Social Access", label: "Share Social Access" },
  { value: "Share your surname", label: "Share your surname" },
  { value: "Share your email", label: "Share your email" },
  { value: "Share your Birthday", label: "Share your Birthday" },
  { value: "Share your career", label: "Share your career" },
];

export const CountryCode = {
  UK: "+44",
  USA: "+1",
  SouthAfrica: "+27",
  Ireland: "+353",
  German: "+49",
  France: "+33",
  Canada: "+1",
  India: "+91",
  Australia: "+61",
};

export const CountryImages = {
  "+44": uk_img,
  "+1": usa_img,
  "+27": southafrica_img,
  "+353": ireland_img,
  "+49": german_img,
  "+33": france_img,
  "+91": india_img,
  "+61": australia_img,
};

export const CountryFlags = {
  UK: uk_img,
  USA: usa_img,
  SouthAfrica: southafrica_img,
  Ireland: ireland_img,
  German: german_img,
  France: france_img,
  Canada: canada_img,
  India: india_img,
  Australia: australia_img,
};

export const notificationImages = {
  "New referral": collaboration_img,
  "New customer message": notification_img,
};

export const defaultNotifications = [
  {
    item: "",
    name: "New referral",
    admin_type: "Sales Rep + Sales manager",
    count: 0,
    lastEvent: null,
  },
  {
    item: "",
    name: "New customer message",
    admin_type: "Chat support agent",
    count: 0,
    lastEvent: null,
  },
];

// File size limit for file uploads e.g. on /featured-content
// limit is set to 140MB
export const UPLOAD_LIMIT = 1024 * 1024 * 140;

export const brandMapping = [
  {
    substring: "weshare",
    brandId: 664,
    title: "UHSM - Portal",
    brandName: "WeShare",
  },
  {
    substring: "eyelineads",
    brandId: 934,
    title: "Eye Line Ads - Portal",
    brandName: "Eye Line Ads",
  },
  {
    substring: "dmcoin",
    brandId: 938,
    title: "Digital Market Coin - Portal",
    brandName: "Digital Market Coin",
  },
  {
    substring: "metaversity",
    brandId: 880,
    title: "Metaversity - Portal",
    brandName: "Metaversity",
  },
  {
    substring: "lowes",
    brandId: 945,
    title: "Lowe's - Portal",
    brandName: "Lowes",
  },
];

export const TerritoryIcons = {
  UK: uk_img,
  Ireland: ireland_img,
  USA: usa_img,
  Canada: canada_img,
  Australia: australia_img,
  German: german_img,
  France: france_img,
  India: india_img,
  SouthAfrica: southafrica_img,
};

export const StageIcons = {
  "Test Roll Out": EcosystemTrialIcon,
  "Full Roll Out": EcosystemGoIcon,
  "Pro Roll Out": EcosystemProIcon,
};

export const coins = {
  UK: PoundCoin,
  USA: DollarCoin,
  SouthAfrica: DollarCoin,
  Ireland: EuroCoin,
  German: EuroCoin,
  France: EuroCoin,
  Canada: DollarCoin,
  India: DollarCoin,
  Australia: DollarCoin,
};



// WEBPACK FOOTER //
// ./src/Utils/Constants.js